export default __webpack_public_path__ + "static/media/background-phone-subtitle-1x.307e6b1d.png";